<template>
    <div class="header">
        <el-button type="primary" @click="handlebackIndex">回到首页</el-button>
        <!-- 用户已登录 -->
        <div class="nav-right" v-if="loginStatus">
            <el-dropdown @command="handleCommand">
                <span class="el-dropdown-link">
                    <i class="el-icon-user"></i>
                    {{ loginUserInfo.name }}
                    <i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item command="logout">
                        退出
                    </el-dropdown-item>
                </el-dropdown-menu>
            </el-dropdown>
        </div>
    </div>
</template>

<script>
import { getSessionRequest, logout } from "@/api/components/mlLayout";

export default {
    data() {
        return {
            // 登录弹出层状态
            dialogVisible: false,
            // 登录方式, 校内登录： loginOnCampus, 校外登录：outside
            loginWay: "loginOnCampus",
            // 登录状态
            loginStatus: false,
            // 登录用户信息
            loginUserInfo: {}
        };
    },
    computed: {
        listenshowpage1() {
            return this.$store.state.userInfo;
        }
    },
    watch: {
        listenshowpage1: function(a, b) {
            console.log("修改前卫：" + a);
            console.log("修改后为：" + b);
        }
    },
    created() {
        // 获取用户session信息
        
        if (JSON.stringify(this.$store.state.userInfo) !== "{}") {
            this.updateUserInfo(this.$store.state.userInfo);
        } else {
            this.getSessionInfo();
        }
    },
    methods: {
        
        /**
         * @name: 返回主页
         * @desc: 
         * @author: lxy
         * @date: 20210906
         */
        handlebackIndex(){
            this.$router.push('/')
        },
        // 提供给refs方法，更新用户信息
        // status 登录状态 true为登录 false为未登录
        updateUserInfo(userInfo, status = true) {
            // if (!status) {
            //     this.$router.push("/");
            // }

            this.loginStatus = status;
            this.loginUserInfo = userInfo;
            this.$store.commit("updateUserInfo", userInfo);


        },
        // 获取用户session的信息
        getSessionInfo() {
            getSessionRequest().then(res => {
                // 拿到session信息，更新一下
                if (res.userinfo === "") {
                    // 未登录
                    this.updateUserInfo({}, false);
                } else {
                    // 已登录
                    this.updateUserInfo(res.userinfo);
                }
            });
        },
        // 退出按钮被点击
        handleCommand(command) {
            if (command === "logout") {
                logout().then(() => {
                    this.$router.push("/");
                    this.$message.success("已退出");
                    this.updateUserInfo({}, false);
                });
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.header {
    height: 100%;
    margin: 0 auto;

    a,
    .el-dropdown {
        line-height: $header-height;
        text-align: center;
    }

    a {
        height: $header-height;
    }

    .el-dropdown {
        height: $header-height / 2 + 9.5px;
    }

    .nav-right {
        width: 105px;
        float: right;

        a {
            display: inline-block;

            &:not(:first-child) {
                margin-left: 7px;

                &::before {
                    content: "";
                    display: inline-block;
                    position: relative;
                    top: 2px;
                    width: 1px;
                    height: 14px;
                    margin-right: 7px;
                    background-color: #fff;
                }
            }
        }
    }
    .el-button{
        line-height: 100%;
        margin-left: 21px;
        margin-top: 8px;
    }
}
</style>
